import request from '@/utils/request'

// 补充资料
export function supplementOrderAfterSaleReq(query) {
  return request({
    url: '/api/orderAfterSale/supplementOrderAfterSale',
    method: 'POST',
    params: query , //params修改为data
  })
}

//提交退货申请
export function addOrderAfterSaleReq(query) {
  return request({
    url: '/api/orderAfterSale/addOrderAfterSale',
    method: 'POST',
    params: query , //params修改为data
  })
}

//获取售后列表
export function orderAfterSaleListReq(query) {
  return request({
    url: '/api/orderAfterSale/orderAfterSaleList',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取售后详情
export function orderAfterSaleDetailReq(query) {
  return request({
    url: '/api/orderAfterSale/orderAfterSaleDetail',
    method: 'GET',
    params: query , //params修改为data
  })
}
//添加快递公司
export function addExpressCompanyReq(query) {
  return request({
    url: '/api/orderAfterSale/addExpressCompany',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取售后数量
export function getAfterSaleQuantityReq(query) {
  return request({
    url: '/api/orderAfterSale/getAfterSaleQuantity',
    method: 'GET',
    params: query , //params修改为data
  })
}
